//
import { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { fromJS } from "immutable"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import { selectActionCentersList } from "shared/grassroots/selectors"

import { parseAndGenerateGamificationFilters } from "shared/search/components/FilterableListView/helperFunctions"

export const createGrassrootsActivityGroup = (uniqueFilterGroupId, customDataType, additionalFilters = []) => {
    const mapStateToProps = (state, props) => ({ actionCentersList: selectActionCentersList(state, props) })

    class UnconnectedGrassrootsActivityGroup extends Component {
        shouldComponentUpdate(nextProps) {
            return (
                !fromJS(nextProps.actionCentersList).equals(fromJS(this.props.actionCentersList)) ||
                nextProps.searchFilterTerm !== this.props.searchFilterTerm
            )
        }

        render() {
            const gamificationLevelFilters = parseAndGenerateGamificationFilters(this.props.actionCentersList)

            let allFilters = gamificationLevelFilters
            if (this.props.additionalFilters.length) {
                allFilters = this.props.additionalFilters.concat(gamificationLevelFilters)
            }

            return genericFilterGroup({
                uniqueFilterGroupId,
                additionalFilters,
                filters: allFilters,
                displayLabel: "Grassroots Activity",
                helpText: "Filter contacts that have or haven't participated in a particular grassroots campaign.",
                ...this.props,
            })
        }
    }

    UnconnectedGrassrootsActivityGroup.propTypes = {
        actionCentersList: PropTypes.array.isRequired,
        loadCustomFields: PropTypes.func.isRequired,
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
        additionalFilters: PropTypes.array,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,
    }

    const connectedFilterGroup = connect(mapStateToProps, null)(UnconnectedGrassrootsActivityGroup)
    Object.assign(connectedFilterGroup, {
        defaultProps: {
            uniqueFilterGroupId,
            customDataType,
            additionalFilters,
        },
    })

    return connectedFilterGroup
}
